// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-597d4f68] .image,[data-v-597d4f68] .image img{width:100%}[data-v-597d4f68] .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}[data-v-597d4f68] .image-style-side img{display:block;margin:0 auto;max-width:100%;min-width:50px}", ""]);
// Exports
module.exports = exports;
